import * as H from 'history';
import React from 'react';
import { Button, Chip } from '@material-ui/core';
import { MyColumn } from '../../common/models';
import { MIXED_BANNER_TYPES } from '../../api/models';

const TYPE_COLORS: { [type: string]: any } = {
    tag: 'primary',
    spot: 'secondary',
    prize: 'default',
    coupon: 'default',
    url: 'default'
}

/** Tag values, rendered as the hashtags ops actually typed on the Tag page. */
export const formatTagValues = (row: any): string => {
    const tags = row.tags != null && row.tags.length > 0
        ? row.tags
        : (row.tag != null ? [row.tag] : []);
    if (tags.length === 0) {
        return '';
    }
    return tags.map((tag: any) => `#${tag.value}`).join(', ');
}

/** `2026-09-15T02:00:00` -> `2026-09-15 02:00`; empty when unset. */
export const formatBannerDate = (value?: string | null): string => {
    if (value == null || value === '') {
        return '';
    }
    return String(value).replace('T', ' ').slice(0, 16);
}

export const getColumns =(history: H.History, editMode: boolean =false, onEditBanner?: (row: any) => void): MyColumn[] => {
    let normal = [
        { title: 'Id', name: 'id', editable: false},
        {
            title: 'Type',
            name: 'type',
            editable: true,
            // Never inferred: ops picks the type explicitly. `tag` rows open the
            // campaign dialog instead of being created inline (see onRowAdded).
            editorOptions: MIXED_BANNER_TYPES,
            getCellValue: (row: any) => {
                if (row.type == null || row.type === '') {
                    return '';
                }
                return (
                    <Chip
                        label={row.type}
                        color={TYPE_COLORS[row.type] != null ? TYPE_COLORS[row.type] : 'default'}
                    />
                );
            }
        },
        { title: 'Published', name: 'published', editable: true, getCellValue: (row: any) => {
            return row.published != null ? row.published.toString() : ""
        }},
        { title: 'Priority', name: 'priority', editable: true},
        {
            title: 'Tags',
            name: 'tags',
            editable: false,
            getCellValue: (row: any) => formatTagValues(row)
        },
        {
            title: 'Valid from',
            name: 'validFrom',
            editable: false,
            getCellValue: (row: any) => formatBannerDate(row.validFrom)
        },
        {
            title: 'Valid until',
            name: 'validUntil',
            editable: false,
            getCellValue: (row: any) => formatBannerDate(row.validUntil)
        },
        { title: 'Image Id', name: 'imageId', editable: true, getCellValue: (row: any) => {
            if (row.imageId != null) {
                return row.imageId;
            } else if (row.image != null) {
                return row.image.id;
            }
        }},
        {
            title: 'Spot Id',
            name: 'spotId',
            editable: true,
            getCellValue: (row: any) => {
                if (row.spotId) {
                    return row.spotId;
                } else if (row.spot != null) {
                    return row.spot.id;
                }
            }
        },
        {
            title: 'Coupon Id',
            name: 'couponId',
            editable: true,
            getCellValue: (row: any) => {
                if (row.couponId != null){
                    return row.couponId;
                } else if (row.coupon != null) {
                    return row.coupon.id;
                }
            }
        },
        {
            title: 'Prize Id',
            name: 'prizeId',
            editable: true,
            getCellValue: (row: any) => {
                if (row.prizeId != null) {
                    return row.prizeId;
                } if (row.prize != null) {
                    return row.prize.id;
                }
            }
        },
        {
            title: 'Url',
            name: 'url',
            editable: true,
            getCellValue: (row: any) => row.url != null ? row.url : ''
        },
        {
            // Campaign tags can only be changed through the dialog, so tag rows
            // get an explicit edit affordance in the grid.
            title: 'Campaign',
            name: 'campaignActions',
            editable: false,
            getCellValue: (row: any) => {
                if (row.type !== 'tag' || onEditBanner == null) {
                    return '';
                }
                return (
                    <Button
                        size='small'
                        data-testid={`edit-campaign-${row.id}`}
                        onClick={() => onEditBanner(row)}
                    >
                        Edit
                    </Button>
                );
            }
        }
    ]
    return normal;
}
